import { Flex, Text } from "@chakra-ui/react";
import { WithAuth } from "@/hoc";
import { PageHeading, Pills } from "barte-design-system";
import { ColumnDefinition, DynamicTable } from "@/components/DynamicTable";
import { getColorBadgeStatus } from "@/utils";
import { useUserListPage } from "./hooks";
import { STATUS_LABEL_MAP } from "./constants";
import {
  ModalAddUser,
  ModalEditUser,
  ModalDeleteUser,
  UserRowActionsMenu,
} from "./components";
import type { IUser } from "./types";

const Usuarios = () => {
  const {
    users,
    isLoading,
    selectedUser,
    isAddModalOpen,
    openAddModal,
    closeAddModal,
    isEditModalOpen,
    openEditModal,
    closeEditModal,
    isDeleteModalOpen,
    openDeleteModal,
    closeDeleteModal,
  } = useUserListPage();

  const columns: ColumnDefinition<IUser>[] = [
    {
      key: "email",
      title: "Usuários",
      dataIndex: "email",
      render: (email: string) => (
        <Flex align="center">
          <Text>{email}</Text>
        </Flex>
      ),
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      width: "100px",
      align: "center",
      render: (status: string) => (
        <Pills
          variant="light"
          label={STATUS_LABEL_MAP[status] || status}
          state={getColorBadgeStatus(status)}
          size="sm"
        />
      ),
    },
    {
      key: "actions",
      title: "",
      dataIndex: "id",
      width: "60px",
      align: "right",
      render: (_: unknown, record: IUser) =>
        record?.status !== "CREATED" ? (
          <UserRowActionsMenu
            user={record}
            onEdit={openEditModal}
            onDelete={openDeleteModal}
          />
        ) : null,
    },
  ];

  return (
    <Flex w="100%" justify="center" flexDir="column" gap="1rem">
      <PageHeading
        title="Usuários"
        primaryActionLabel="Adicionar usuário"
        onPrimaryAction={openAddModal}
      />

      <Flex flexDir="column" width="100%" gap="1rem" py="4">
        <DynamicTable
          columns={columns}
          data={users}
          rowKey={(record) => String(record.id)}
          loading={isLoading}
          locale={{ emptyText: "Sem dados de usuários" }}
        />
      </Flex>

      <ModalAddUser isOpen={isAddModalOpen} onClose={closeAddModal} />
      <ModalEditUser isOpen={isEditModalOpen} onClose={closeEditModal} user={selectedUser} />
      <ModalDeleteUser isOpen={isDeleteModalOpen} onClose={closeDeleteModal} user={selectedUser} />
    </Flex>
  );
};

export default WithAuth(Usuarios);
